// angular import
import { Component, OnInit } from '@angular/core';
import { AuthResourceService } from '@mri/app/resources';
import { Subscription, tap } from 'rxjs';

@Component({
  selector: 'app-nav-bar',
  templateUrl: './toolbar.component.html',
  styleUrls: ['./toolbar.component.scss']
})
export class NavBarComponent implements OnInit{
  private _subscription = new Subscription();
  // public props
  HeaderBlur: boolean;
  headerColoring: boolean;

  constructor(
    private _authSrv: AuthResourceService
  ) {
  }

  ngOnInit() {
    this._subscription.add(
      this._authSrv.authFirst$.pipe(
        tap( auth => {
          this.headerColoring = auth?.personalize?.headerColoring || false;
        })
      ).subscribe()
    );

    this._subscription.add(
      this._authSrv.onChangeAuth$.pipe(
        tap( auth => {
          this.headerColoring = auth?.personalize?.headerColoring || false;
        })
      ).subscribe()
    );
  }
}
